// to distinguish between other certificate and no certificate, we use the the OTHER_CERTIFICATE in the frontend.
export const OTHER_CERTIFICATE_ID = 'OTHER_CERTIFICATE';
